// Zip to city name mapping for display — covers South Jersey, shore, and surrounding areas
const ZIP_CITY = {
  "08001":"Penns Grove","08002":"Cherry Hill","08003":"Cherry Hill","08004":"Atco",
  "08005":"Barnegat","08006":"Barnegat Light","08007":"Barrington","08008":"Beach Haven",
  "08009":"Berlin","08010":"Beverly","08011":"Browns Mills","08012":"Blackwood",
  "08014":"Bridgeport","08015":"Browns Mills","08016":"Burlington","08018":"Cedar Brook",
  "08019":"Chatsworth","08020":"Clarksboro","08021":"Clementon","08022":"Columbus",
  "08023":"Deepwater","08025":"Franklinville","08026":"Gibbsboro","08027":"Gibbstown",
  "08028":"Glassboro","08029":"Glendora","08030":"Gloucester City","08031":"Bellmawr",
  "08032":"Grenloch","08033":"Haddonfield","08034":"Cherry Hill","08035":"Haddon Heights",
  "08036":"Hainesport","08037":"Hammonton","08038":"Hancocks Bridge","08039":"Harrisonville",
  "08041":"Jobstown","08042":"Kinkora","08043":"Voorhees","08045":"Lawnside",
  "08046":"Willingboro","08048":"Lumberton","08049":"Magnolia","08050":"Manahawkin",
  "08051":"Mantua","08052":"Maple Shade","08053":"Marlton","08054":"Mount Laurel",
  "08055":"Medford","08056":"Mickleton","08057":"Moorestown","08059":"Mount Ephraim",
  "08060":"Mount Holly","08061":"Mount Royal","08062":"Mullica Hill","08063":"National Park",
  "08064":"New Lisbon","08065":"Palmyra","08066":"Pitman","08067":"Pedricktown",
  "08068":"Pemberton","08069":"Penns Grove","08070":"Pennsville","08071":"Pitman",
  "08072":"Richwood","08073":"Rancocas","08074":"Repaupo","08075":"Riverton",
  "08076":"Swedesboro","08077":"Riverton","08078":"Runnemede","08079":"Salem",
  "08080":"Sewell","08081":"Sicklerville","08083":"Somerdale","08084":"Stratford",
  "08085":"Swedesboro","08086":"Thorofare","08087":"Tuckerton","08088":"Vincentown",
  "08089":"Waterford Works","08090":"Wenonah","08091":"West Berlin","08092":"West Creek",
  "08093":"Westville","08094":"Williamstown","08095":"Winslow","08096":"Woodbury",
  "08097":"Woodbury Heights","08098":"Woodstown","08101":"Camden","08102":"Camden",
  "08103":"Camden","08104":"Camden","08105":"Camden","08106":"Audubon",
  "08107":"Oaklyn","08108":"Collingswood","08109":"Merchantville","08110":"Pennsauken",
  "08201":"Absecon","08202":"Avalon","08203":"Brigantine","08204":"Cape May",
  "08205":"Galloway","08210":"Cape May Court House","08212":"Cape May Point",
  "08215":"Egg Harbor City","08217":"Elwood","08221":"Linwood","08223":"Marmora",
  "08224":"New Gretna","08225":"Northfield","08226":"Ocean City","08230":"Ocean View",
  "08232":"Pleasantville","08234":"Egg Harbor Township","08240":"Pomona",
  "08241":"Port Republic","08242":"Rio Grande","08243":"Sea Isle City",
  "08244":"Somers Point","08245":"South Dennis","08246":"South Seaville",
  "08247":"Stone Harbor","08248":"Strathmere","08250":"Tuckahoe","08251":"Villas",
  "08252":"Whitesboro","08260":"Wildwood","08270":"Woodbine",
  "08310":"Buena","08311":"Cedarville","08312":"Clayton","08314":"Delmont",
  "08316":"Dorchester","08317":"Dorothy","08318":"Elmer","08319":"Estell Manor",
  "08320":"Fairton","08321":"Fortescue","08322":"Franklinville","08323":"Greenwich",
  "08324":"Heislerville","08326":"Landisville","08327":"Leesburg","08328":"Malaga",
  "08329":"Mauricetown","08330":"Mays Landing","08332":"Millville","08340":"Milmay",
  "08341":"Minotola","08342":"Monroeville","08343":"Newfield","08344":"Newtonville",
  "08345":"Newport","08346":"Newtonville","08348":"Port Elizabeth","08349":"Port Norris",
  "08350":"Richland","08352":"Rosenhayn","08353":"Shiloh","08360":"Vineland",
  "08361":"Vineland","08362":"Vineland",
  "08401":"Atlantic City","08402":"Margate City","08403":"Longport",
  "08404":"Atlantic City","08405":"Atlantic City","08406":"Ventnor City",
};
function getCityFromZip(zip) { return ZIP_CITY[zip] || null; }

// Zip code lat/lng for South Jersey distance calculation
const ZIP_COORDS = {
  "08001":[39.703,-75.471],"08002":[39.934,-75.014],"08003":[39.901,-74.974],"08004":[39.793,-74.760],
  "08005":[39.753,-74.268],"08006":[39.756,-74.103],"08007":[39.868,-75.061],"08008":[39.651,-74.192],
  "08009":[39.788,-74.947],"08010":[40.064,-74.919],"08011":[39.972,-74.580],"08012":[39.778,-75.044],
  "08014":[39.803,-75.351],"08015":[39.972,-74.580],"08016":[40.078,-74.862],"08018":[39.724,-74.908],
  "08019":[39.778,-74.516],"08020":[39.800,-75.224],"08021":[39.810,-75.018],"08022":[40.066,-74.691],
  "08023":[39.666,-75.505],"08025":[39.613,-75.065],"08026":[39.821,-74.977],"08027":[39.825,-75.223],
  "08028":[39.702,-75.112],"08029":[39.809,-75.057],"08030":[39.889,-75.122],
  "08031":[39.877,-75.097],"08032":[39.771,-75.063],"08033":[39.893,-75.036],"08034":[39.913,-74.997],
  "08035":[39.884,-75.052],"08036":[39.957,-74.836],"08037":[39.640,-74.759],
  "08038":[39.497,-75.338],"08039":[39.644,-75.232],"08041":[40.044,-74.692],
  "08042":[40.063,-74.737],"08043":[39.855,-74.971],"08045":[39.857,-75.037],
  "08046":[40.028,-74.882],"08048":[39.951,-74.804],"08049":[39.856,-75.038],
  "08050":[39.693,-74.257],"08051":[39.785,-75.173],"08052":[39.946,-74.999],
  "08053":[39.896,-74.919],"08054":[39.952,-74.936],"08055":[39.827,-74.772],
  "08056":[39.782,-75.241],"08057":[39.956,-74.951],"08059":[39.903,-75.055],
  "08060":[40.019,-74.800],"08061":[39.811,-75.196],"08062":[39.741,-75.218],
  "08063":[39.821,-75.220],"08064":[39.967,-74.621],"08065":[39.950,-75.050],
  "08066":[39.732,-75.131],"08067":[39.733,-75.406],"08068":[39.972,-74.683],
  "08069":[39.703,-75.471],"08070":[39.644,-75.516],"08071":[39.732,-75.131],
  "08072":[39.723,-75.165],"08073":[39.991,-74.874],"08074":[39.836,-75.198],
  "08075":[40.025,-74.950],"08076":[39.747,-75.310],"08077":[39.977,-75.017],
  "08078":[39.849,-75.065],"08079":[39.570,-75.471],"08080":[39.804,-75.115],
  "08081":[39.741,-74.992],"08083":[39.840,-75.020],"08084":[39.829,-75.011],
  "08085":[39.747,-75.310],"08086":[39.851,-75.180],"08087":[39.596,-74.340],
  "08088":[39.889,-74.697],"08089":[39.776,-74.870],"08090":[39.832,-75.117],
  "08091":[39.771,-74.972],"08092":[39.661,-74.300],"08093":[39.871,-75.140],
  "08094":[39.729,-74.982],"08095":[39.700,-74.880],"08096":[39.825,-75.127],
  "08097":[39.849,-75.137],"08098":[39.652,-75.331],
  "08101":[39.931,-75.120],"08102":[39.945,-75.112],"08103":[39.931,-75.100],
  "08104":[39.922,-75.090],"08105":[39.937,-75.082],"08106":[39.910,-75.047],
  "08107":[39.920,-75.062],"08108":[39.910,-75.027],"08109":[39.945,-75.070],
  "08110":[39.965,-75.037],
  "08201":[39.429,-74.500],"08202":[39.102,-74.715],"08203":[39.410,-74.359],
  "08204":[38.935,-74.906],"08205":[39.487,-74.480],"08210":[39.082,-74.823],
  "08212":[38.933,-74.960],"08215":[39.527,-74.648],"08217":[39.567,-74.718],
  "08221":[39.341,-74.574],"08223":[39.256,-74.685],"08224":[39.597,-74.448],
  "08225":[39.371,-74.548],"08226":[39.297,-74.592],"08230":[39.243,-74.724],
  "08232":[39.386,-74.526],"08234":[39.396,-74.587],"08240":[39.479,-74.572],
  "08241":[39.517,-74.489],"08242":[39.013,-74.882],"08243":[39.153,-74.694],
  "08244":[39.506,-74.454],"08245":[39.179,-74.831],"08246":[39.197,-74.793],
  "08247":[39.047,-74.761],"08248":[39.209,-74.662],"08250":[39.283,-74.767],
  "08251":[39.020,-74.945],"08260":[38.988,-74.815],"08270":[39.240,-74.818],
  "08310":[39.519,-74.926],"08311":[39.386,-75.204],"08312":[39.663,-75.093],
  "08314":[39.236,-75.066],"08316":[39.311,-75.093],"08317":[39.464,-74.833],
  "08318":[39.580,-75.160],"08319":[39.416,-74.758],"08320":[39.377,-75.191],
  "08321":[39.224,-75.144],"08322":[39.613,-75.065],"08323":[39.388,-75.349],
  "08324":[39.243,-74.993],"08326":[39.500,-74.937],"08327":[39.235,-74.980],
  "08328":[39.578,-75.026],"08329":[39.299,-75.070],"08330":[39.453,-74.724],
  "08332":[39.370,-75.041],"08340":[39.478,-74.879],"08341":[39.518,-74.962],
  "08342":[39.625,-75.153],"08343":[39.568,-75.021],"08344":[39.577,-74.874],
  "08345":[39.278,-75.159],"08346":[39.577,-74.874],"08348":[39.287,-75.003],
  "08349":[39.239,-75.054],"08350":[39.477,-74.860],"08352":[39.475,-75.131],
  "08353":[39.457,-75.305],"08360":[39.486,-75.026],"08361":[39.447,-74.989],
  "08362":[39.420,-75.006],
  "08401":[39.364,-74.423],"08402":[39.327,-74.511],"08403":[39.312,-74.532],
  "08404":[39.364,-74.423],"08405":[39.364,-74.423],"08406":[39.341,-74.451]
};

function getCoords(zip) { return ZIP_COORDS[zip] || null; }

const RADIUS_OPTIONS = [5, 10, 15, 20, 30, 50];

export { ZIP_CITY, ZIP_COORDS, getCityFromZip, getCoords, RADIUS_OPTIONS };
